import { BlockLoader } from './loading';

/** Centered "Loading..." spinner used by the report/log pages.
 *
 * Extracted from DailyAttendanceLogsPage / GroomingReportPage /
 * MoodReportPage / RandomAttendanceLogsPage, where this exact markup was the
 * body of each page's `{loading && (...)}` block. The conditional stays in the
 * page; only the identical inner markup lives here.
 * Drawn with the loading kit's ring; the padding (py-16) and the words are what
 * they always were. */
export function ReportLoadingState() {
  return <BlockLoader label="Loading..." className="py-16" />;
}
